// extracted by mini-css-extract-plugin
export default {"container":"Incident_container__GfIau","page":"Incident_page__U3Do6","section":"Incident_section__GbK+i"};